import { FilterDataType } from './filter-data.type';
import { SortType } from './sort.type';

export class FilterType {
    page: number;
    pageSize: number;
    logic: string;
    filter: FilterDataType;
    sort: Array<SortType>;

    constructor() {
        this.clearFilter();             
    }

    clearFilter() {
        this.page = 1;
        this.pageSize = 12;
        // this.filter = new FilterDataType();        
    }
}
